import React, {Component} from 'react';
import Input from "../../../../../components/textbox/Input";
import styles from "../../InfoCliniche/InfoCliniche.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import {withTranslation} from "react-i18next";

class MalformazioniNeonatali extends Component {

    state = {
        malformazioniNeonatali: {
            tipoMalformazione: "",
            metodoRilevazione: "",
            dataRilevazione: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.validate = this.validate.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {

        this.controlloCorrettezza()
        this.props.setMalformazioniNeonatali(undefined, this)
        if (this.props.segnalazioneCopia.datiSpecifici) {
            if (this.props.segnalazioneCopia.datiSpecifici.malformazioniNeonatali) {
                let malformazioniNeonatali = this.state.malformazioniNeonatali;
                let malformazioniNeonataliCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici))
                malformazioniNeonatali.tipoMalformazione = malformazioniNeonataliCopia.malformazioniNeonatali.tipoMalformazione ? malformazioniNeonataliCopia.malformazioniNeonatali.tipoMalformazione : ""
                malformazioniNeonatali.metodoRilevazione = malformazioniNeonataliCopia.malformazioniNeonatali.metodoRilevazione ? malformazioniNeonataliCopia.malformazioniNeonatali.metodoRilevazione : ""
                malformazioniNeonatali.dataRilevazione = malformazioniNeonataliCopia.malformazioniNeonatali.dataRilevazione ? malformazioniNeonataliCopia.malformazioniNeonatali.dataRilevazione : ""


                this.setState({malformazioniNeonatali: malformazioniNeonatali})
                this.props.setMalformazioniNeonatali(this.state.malformazioniNeonatali)
                this.controlloCorrettezza()
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            this.props.setMalformazioniNeonatali(this.state.malformazioniNeonatali, this)
        }
    }

    controlloCorrettezza() {
        let malformazioniNeonatali = this.state.malformazioniNeonatali
        malformazioniNeonatali.corretto = []

        if (malformazioniNeonatali.dataRilevazione && Utils.isDateInValid(Utils.transformDateForBackend(malformazioniNeonatali.dataRilevazione), "-")){
            malformazioniNeonatali.corretto[0] = "Campo \"Data Di Rilevazione\" errato"
        } else malformazioniNeonatali.corretto[0] = ""

        return this.setState({malformazioniNeonatali: malformazioniNeonatali})
    }

    riceviValore(field, event) {
        let malformazioniNeonatali = this.state.malformazioniNeonatali
        if (field === "metodoRilevazione") {
            malformazioniNeonatali.metodoRilevazione = event.target.value
        } else if (field === "tipoMalformazione") {
            malformazioniNeonatali.tipoMalformazione = event.target.value
        } else if (field.currentTarget) {
            if (field.currentTarget.id === "dataRilevazione") {
                malformazioniNeonatali.dataRilevazione = field.target.value
            }
        }

        this.setState({malformazioniNeonatali: malformazioniNeonatali})
        this.controlloCorrettezza()
    }

    validate() {
        let validateDataRilevazione = Utils.checkDateInterval(this.state.malformazioniNeonatali.dataRilevazione, "31/12/1899");
        let checkTodayDataRilevazione = Utils.checkDateLowerToday(this.state.malformazioniNeonatali.dataRilevazione);
        if (validateDataRilevazione) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_AE"]), 1
            )
        } else if (checkTodayDataRilevazione) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_AF"]), 1
            )
        }

        let malformazioniNeonatali = Object.assign({}, this.state.malformazioniNeonatali)
        let malformazioniNeonataliObj = Utils.removeFieldFromObject(malformazioniNeonatali, "corretto");

        this.props.setMalformazioniNeonatali(undefined, undefined, malformazioniNeonataliObj)


    }

    render() {
        const {t} = this.props
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("DatiSpecifici.Malformazioni.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>

                    <div className="row">
                        <div className={"col-lg-12"}>
                            <p className={styles.testo}>{t("DatiSpecifici.Malformazioni.tipo")}</p>
                            <Input type={"textarea"}
                                   placeholder="campo a testo libero"
                                   value={this.state.malformazioniNeonatali.tipoMalformazione}
                                   onChange={this.riceviValore}
                                   id="tipoMalformazione"
                                   field={"tipoMalformazione"}
                                   onValidate={this.state.malformazioniNeonatali.tipoMalformazione.startsWith(" ") ? 1 : 2} /// onValidate: 1 errore,  altro valore ok
                                   errorMessage={"Campo informazioni aggiuntive non valido"}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className={"col-lg-12"}>
                            <p className={styles.testo}>{t("DatiSpecifici.Malformazioni.metodoRilevazione")}</p>
                            <Input type={"textarea"}
                                   placeholder="campo a testo libero"
                                   onChange={this.riceviValore}
                                   value={this.state.malformazioniNeonatali.metodoRilevazione}
                                   id="metodoRilevazione"
                                   field={"metodoRilevazione"}
                                   onValidate={this.state.malformazioniNeonatali.metodoRilevazione.startsWith(" ") ? 1 : 2} /// onValidate: 1 errore,  altro valore ok
                                   errorMessage={"Campo informazioni aggiuntive non valido"}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className={"col-lg-3"}>
                            <p className={styles.testo} style={{color: "#1b7ea9"}}>
                                {t("DatiSpecifici.Malformazioni.dataRilevazione")}
                            </p>
                            <Calendar
                                id={"dataRilevazione"} value={this.state.malformazioniNeonatali.dataRilevazione}
                                field={"dataRilevazione"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>",
                                    t("Data Di Rilevazione"))}
                                error={(this.state.malformazioniNeonatali.dataRilevazione === "" ||
                                    this.state.malformazioniNeonatali.dataRilevazione == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.malformazioniNeonatali.dataRilevazione), "-")}
                            >
                            </Calendar>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(MalformazioniNeonatali)
